import {Injectable} from '@angular/core';

@Injectable()
export class CsAgGridJsScriptHandlerService {

    private scriptElement: HTMLScriptElement | null = null;
    private isLoaded = false;
    private loadPromise: Promise<void> | null = null;
    private scriptUrl = 'javascripts/ag-grid-enterpriseV33.1.0/ag-grid-enterprise.min.js';

    constructor() {
    }

    /* Note: Handling the ag-grid CDN script dynamically.
     - Due to the issue of conflicting the styles & functionalities b/w AG-Grid Angular & AG-Grid Js approaches.
     */
    async loadAgGridScript(): Promise<void> {
        if (this.isLoaded || (window as any).agGrid) {
            return Promise.resolve(); // ag-Grid is already in memory, no need to reload
        }

        if (this.loadPromise) {
            return this.loadPromise;
        }

        this.loadPromise = new Promise((resolve, reject) => {
            this.scriptElement = document.createElement('script');
            this.scriptElement.src = this.scriptUrl;
            this.scriptElement.async = true;
            this.scriptElement.onload = () => {
                this.isLoaded = true;

                resolve();
            };
            this.scriptElement.onerror = () => {
                this.isLoaded = false;
                this.loadPromise = null;
                reject(new Error('Failed to load ag-Grid JS'));
            };

            document.body.appendChild(this.scriptElement);
        });

        await this.isGridInstanceAvailable();

        return this.loadPromise;
    }

    isGridInstanceAvailable(): Promise<void> {
        // Wait until ag-Grid JS is fully available
        return new Promise<void>((resolve) => {
            let attempts = 0;

            const interval = setInterval(() => {
                attempts++;
                const agGrid = (window as any).agGrid;


                if (this.isLoaded && agGrid && agGrid.createGrid) {
                    clearInterval(interval);

                    resolve();
                }
            }, 50);
        });
    }

    // Add a method to verify script is loaded
    isScriptLoaded(): boolean {
        const agGrid = (window as any).agGrid;
        return !!(agGrid && agGrid.createGrid);
    }

    // Add a method to get script status for debugging
    getScriptStatus(): {
        isLoaded: boolean;
        agGridExists: boolean;
        createGridExists: boolean;
        scriptElementExists: boolean;
    } {
        const agGrid = (window as any).agGrid;
        return {
            isLoaded: this.isLoaded,
            agGridExists: !!agGrid,
            createGridExists: !!(agGrid && agGrid.createGrid),
            scriptElementExists: !!this.scriptElement
        };
    }

    // Reset script handler state to allow reload
    resetScriptState(): void {
        this.isLoaded = false;
        this.loadPromise = null;
    }

    removeAgGridScript() {
        if (this.scriptElement) {
            this.scriptElement.remove(); // Detach from DOM but keep in memory
            this.scriptElement = null;
        }
    }

    // -------------------------------------------------------------------------------------------------------------
}
